import { Component, Input, OnInit, OnChanges, ViewEncapsulation } from '@angular/core';
import { UserBoard, UserBoardComponentMode, UserBoardItem } from 'src/app/services/models/user-board.model';
import { CompactType, DisplayGrid, GridsterConfig, GridType } from 'angular-gridster2';
import { FilterBar } from 'src/app/services/models/filter-bar.model';
import { FilterBarService } from 'src/app/services/filter-bar.service';
import { SelectedFilterUpdatesService } from 'src/app/common/bhub-common-module/services/selected-filter-updates.service';

@Component({
  selector: 'bhub-tile-board-viewer',
  templateUrl: './tile-board-viewer.component.html',
  styleUrls: ['./tile-board-viewer.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class TileBoardViewerComponent implements OnInit, OnChanges {
  @Input() board: UserBoard;
  @Input() filterBar: FilterBar;

  gridsterOptions: GridsterConfig;

  constructor(
    private filterBarService: FilterBarService,
    private selectedFilterUpdater: SelectedFilterUpdatesService
  ) {}

  ngOnInit() {
    this.setupGridsterOptions();
    this.prepareBoard();
  }

  ngOnChanges() {
    if (this.board) {
      this.prepareBoard();
      this.loadFilterBar();
    }
  }

  private setupGridsterOptions(): void {
    this.gridsterOptions = {
      gridType: GridType.Fixed,
      compactType: CompactType.None,
      margin: 10,
      outerMargin: true,
      useTransformPositioning: true,
      mobileBreakpoint: 640,
      minCols: 1,
      maxCols: 24,
      minRows: 1,
      maxRows: 18,
      fixedColWidth: 75,
      fixedRowHeight: 75,
      keepFixedHeightInMobile: false,
      keepFixedWidthInMobile: false,
      scrollSensitivity: 10,
      scrollSpeed: 20,
      enableEmptyCellClick: false,
      enableEmptyCellContextMenu: false,
      enableEmptyCellDrop: false,
      enableEmptyCellDrag: false,
      draggable: {
        enabled: true,
      },
      resizable: {
        enabled: true,
      },
      pushItems: true,
      pushResizeItems: true,
      displayGrid: DisplayGrid.OnDragAndResize
    };
  }

  private prepareBoard(): void {
    if (this.board && this.board.itemList) {
      // Set all tile components to live mode for viewing
      this.board.itemList.forEach((item: UserBoardItem) => {
        if (item.data) {
          item.data.mode = UserBoardComponentMode.Live;
        }
      });
    }
  }

  private loadFilterBar(): void {
    if (this.board && this.board.filterBarId) {
      this.filterBarService.getFilterBars().subscribe((filterBars: FilterBar[]) => {
        this.filterBar = filterBars.find((filterBar: FilterBar) => 
          filterBar.filterBarId === this.board.filterBarId
        );
      });
    }
  }

  onSelectedFiltersChanged(selectedFilters: any): void {
    this.selectedFilterUpdater.setFilters(selectedFilters);
  }
}